import server from 'api/server';
import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import { toast } from 'react-toastify';

const DeleteFolderModal = ({ open, onClose, file }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onDelete = async () => {
    try {
      setLoading(true);
      const {
        data: { safe, success }
      } = await server.delete(`/folders/${file.id}`);
      if (!safe) {
        setLoading(false);
        setDisabled(true);
        setError('This folder is not empty and cannot be deleted.');
      }
      if (success) {
        onClose();
        setError('');
        setDisabled(false);
        setLoading(false);
        toast.info('Folder deleted successfully.');
      }
    } catch (error) {
      setLoading(false);
      toast.info('Something went wrong!');
    }
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setDisabled(false);
        setError('');
      }}
      closeOnOverlayClick={false}
    >
      <div className="modal_top">
        <h3 className="title is-h3">Delete Folder</h3>
        <div className="field">
          {!error && (
            <p>
              This will permanently remove the folder. This action cannot be
              undone.
            </p>
          )}
          {error && <p className="help is-danger">{error}</p>}
        </div>
        <hr />
        <div className="field is-grouped">
          <div className="control">
            <button
              disabled={disabled}
              onClick={onDelete}
              className={`button is-info is-small ${loading ? 'is-loading' : ''}`}
            >
              Delete Folder
            </button>
          </div>
          <div className="control">
            <button
              onClick={() => {
                onClose();
                setDisabled(false);
                setError('');
              }}
              className="button is-info is-small is-light"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteFolderModal;
